import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Button, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import loginApi from "api/loginApi";
import LOGO from "assets/img/logo.png";
import InputField from "components/FormFields/InputField";
import { TOKEN, NAME } from "constants/config";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as yup from "yup";

const schema = yup.object().shape({
  email: yup.string().required("Vui lòng nhập Email"),
  password: yup.string().required("Vui lòng nhập mật khẩu"),
});

const SignIn = () => {
  const useStyles = makeStyles((theme) => ({
    background: {
      backgroundColor: "#d4ecee",
      height: "100vh",
      width: "100vw",
      position: "relative",
    },
    root: {
      backgroundColor: "#fff",
      borderRadius: 10,
      boxShadow: "5px 5px 15px 6px rgba(255,194,222,0.52)",
      minHeight: 400,
      width: 400,
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%,-50%)",
      padding: "25px 40px",
    },
    btn_submit: {
      marginTop: 20,
    },
  }));
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState("");
  const initialValues = {
    email: "",
    password: "",
  };

  const { control, handleSubmit } = useForm({
    defaultValues: initialValues,
    resolver: yupResolver(schema),
  });

  const handleSubmitForm = async (values) => {
    try {
      const res = await loginApi.signIn(values);
      if (res.responseCode === "00") {
        localStorage.setItem(TOKEN, res.token);
        localStorage.setItem(NAME, res.name);
        toast.success("Đăng nhập thành công ");
        navigate("/admin/farm");
      } else {
        setError("Tài khoản hoặc mật khẩu không chính xác");
        throw new Error("Tài khoản hoặc mật khẩu không đúng");
      }
    } catch (error) {
    }
  };

  return (
    <Box className={classes.background}>
      <Box className={classes.root}>
        <Box textAlign="center" p={3} pb={1}>
          <img src={LOGO} alt="logo" />
          <Typography variant="h5" color="primary">
            Đăng nhập
          </Typography>
        </Box>
        <Box className={classes.content}>
          <form onSubmit={handleSubmit(handleSubmitForm)}>
            <InputField name="email" label="Email" control={control} />
            <InputField
              name="password"
              label="Password"
              control={control}
              type="password"
            />

            {error && <Alert severity="error">{error}</Alert>}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className={classes.btn_submit}
              disableRipple
            >
              Đăng nhập
            </Button>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default SignIn;
